import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { Button } from "@/components/ui/button";
import secureLocalStorage from "react-secure-storage";

const TrainingCertificate = () => {
  const [trainingForm, setTrainingForm] = useState({});
  const [certificateForm, setCertificateForm] = useState({});
  const [trainingList, setTrainingList] = useState([]);
  const [certificateList, setCertificateList] = useState([]);
  const [editTrainingIndex, setEditTrainingIndex] = useState(null);
  const [editCertificateIndex, setEditCertificateIndex] = useState(null);
  const [loading, setLoading] = useState(true);
	
	const [error, setError] = useState(null);
	const trainingPost = async () => {
		setLoading(true);
		setError(null);

		try {
			const payload = {
				userId: import.meta.env.VITE_API_USER,
				password: import.meta.env.VITE_API_PASS,
				user: secureLocalStorage.getItem("user"),
				token:secureLocalStorage.getItem("token"),
		    };
			const api = axios.create({
				baseURL: import.meta.env.VITE_API_BASE_URL,
				headers: { "Content-Type": "application/json" },
			});
			const response = await api.post("/training-list", payload);
			
			// Loop data (array)
			setTrainingList(response.data || []);			
		} catch (err) {
			console.log(err);
		    setError(err.message || "Something went wrong");		   
		} finally {
		  setLoading(false);
		}
	};
	const certificatePost = async () => {
		setLoading(true);
		setError(null);

		try {
			const payload = {
				userId: import.meta.env.VITE_API_USER,
				password: import.meta.env.VITE_API_PASS,
				user: secureLocalStorage.getItem("user"),
				token:secureLocalStorage.getItem("token"),
		    };
			const api = axios.create({
				baseURL: import.meta.env.VITE_API_BASE_URL,
				headers: { "Content-Type": "application/json" },
			});
			const response = await api.post("/certificate-list", payload);
			
			// Loop data (array)
			setCertificateList(response.data || []);			
		} catch (err) {
			console.log(err);
		    setError(err.message || "Something went wrong");		   
		} finally {
		  setLoading(false);
		}
	};
	useEffect(() => {		
		trainingPost();	
		certificatePost();
	}, []);
  

  // ✅ Generic Handlers
  const handleChange = (e, setter) => {
    const { name, value } = e.target;
    setter((prev) => ({ ...prev, [name]: value }));
  };

	const handleAdd = async (form, setter, listSetter, endpoint) => {
	  try {
		let payload;

		// If form is already FormData, append fields directly
		if (form instanceof FormData) {
		  payload = form;
		} else {
		  // Otherwise, create FormData from object
		  payload = new FormData();
		  Object.entries(form).forEach(([key, value]) => {
			payload.append(key, value);
		  });
		}

		// Append required authentication details
		payload.append("userId", import.meta.env.VITE_API_USER);
		payload.append("password", import.meta.env.VITE_API_PASS);
		payload.append("user", secureLocalStorage.getItem("user"));
		payload.append("token", secureLocalStorage.getItem("token"));
		// Send data to API
		const res = await axios.post(`${import.meta.env.VITE_API_BASE_URL}${endpoint}`, payload, {
		  headers: { "Content-Type": "application/json" },
		});

		// Update list and reset form
		listSetter((prev) => [...prev, res.data]);
		setter({});
		if(endpoint==="/update-training"){
			setTrainingList(res.data || []);
			alert(res?.data?.responseMsg || "✅ Training info saved successfully!");
		}else{
			setCertificateList(res.data || []);
			alert(res?.data?.responseMsg || "✅ Certificate info saved successfully!");
		}

	  } catch (error) {
		console.error("Error adding:", error);
	  }
	};

	const handleUpdate = async (form, setter, listSetter, endpoint) => {
	  try {
		let payload;

		// Handle both FormData and object input
		if (form instanceof FormData) {
		  payload = form;
		} else {
		  payload = new FormData();
		  Object.entries(form).forEach(([key, value]) => {
			payload.append(key, value);
		  });
		}

		// Append authentication info
		payload.append("userId", import.meta.env.VITE_API_USER);
		payload.append("password", import.meta.env.VITE_API_PASS);
		payload.append("user", secureLocalStorage.getItem("user"));
		payload.append("token", secureLocalStorage.getItem("token"));
		// Send PATCH request
		const res = await axios.patch(`${import.meta.env.VITE_API_BASE_URL}${endpoint}/${form.id}`, payload, {
		  headers: { "Content-Type": "application/json" },
		});

		

		// Reset form
		setter({});
		
		if(endpoint==="/update-training"){
			setTrainingList(res.data || []);
			alert(res?.data?.responseMsg || "✅ Training info saved successfully!");
		}else{
			setCertificateList(res.data || []);
			alert(res?.data?.responseMsg || "✅ Certificate info saved successfully!");
		}
		
	  } catch (error) {
		console.error("Error updating:", error);
	  }
	};

  if (loading)
    return (
      <div className="text-center text-blue-600 py-8">
        Loading Training & Certificates...
      </div>
    );

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-white rounded-xl p-6 shadow-md space-y-12"
    >
      {/* ======================
          TRAINING SECTION
      ====================== */}
      <section>
        <h2 className="text-2xl font-semibold text-[#1A2B63] mb-4">
          Training Information
        </h2>

        {/* FORM */}
        <form className="grid grid-cols-2 md:grid-cols-3 gap-5">
          {[
            { label: "Training Title", name: "trainingTitle" },
            { label: "Institution Name", name: "institution" },
            { label: "Country", name: "country" },
            { label: "Modality", name: "modality" },
            { label: "Start Date", name: "startDate", type: "date" },
            { label: "End Date", name: "endDate", type: "date" },
            { label: "Learning Area", name: "learningArea", type: "textarea" },
          ].map((field, i) => (
            <div
              key={i}
              className={`flex flex-col ${
                field.type === "textarea" ? "col-span-full" : ""
              }`}
            >
              <label className="text-gray-700 text-sm font-semibold mb-1">
                {field.label}
              </label>
              {field.type === "textarea" ? (
                <textarea
                  name={field.name}
                  value={trainingForm[field.name] || ""}
                  onChange={(e) => handleChange(e, setTrainingForm)}
                  className="border border-blue-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500 outline-none transition-all duration-200 min-h-[80px]"
                />
              ) : (
                <input
                  type={field.type || "text"}
                  name={field.name}
                  value={trainingForm[field.name] || ""}
                  onChange={(e) => handleChange(e, setTrainingForm)}
                  className="border border-blue-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500 outline-none transition-all duration-200"
                />
              )}
            </div>
          ))}

          <div className="col-span-full flex justify-end gap-3 mt-2">
            {editTrainingIndex !== null && (
              <Button variant="outline" onClick={() => setEditTrainingIndex(null)}>
                Cancel
              </Button>
            )}
            <Button
              onClick={(e) => {
                e.preventDefault();
                editTrainingIndex !== null
                  ? handleUpdate(
                      trainingForm,
                      setTrainingForm,
                      setTrainingList,
                      "/update-training"
                    )
                  : handleAdd(
                      trainingForm,
                      setTrainingForm,
                      setTrainingList,
                      "/update-training"
                    );
              }}
              className="bg-blue-600 text-white"
            >
              {editTrainingIndex !== null ? "Update Training" : "Add Training"}
            </Button>
          </div>
        </form>

        {/* LIST */}
        <div className="mt-8 space-y-4">
          <h3 className="text-xl font-semibold text-[#1A2B63]">
            Training History
          </h3>
          {trainingList.length > 0 ? (
            trainingList.map((tr, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                className="p-4 bg-blue-50 rounded-lg flex justify-between items-start shadow-sm hover:shadow-md transition-all"
              >
                <div>
                  <p className="font-semibold text-blue-800">{tr.trainingTitle}</p>
                  <p className="text-sm text-gray-600">
                    {tr.institution} - {tr.country}
                  </p>
                  <p className="text-sm text-gray-600">
                    {tr.startDate} - {tr.endDate}
                  </p>
                  <p className="text-sm text-gray-500 italic">
                    Learning Area: {tr.learningArea}
                  </p>
                </div>
                <Button
                  size="sm"
                  variant="outline"
                  onClick={() => {
                    setEditTrainingIndex(i);
                    setTrainingForm(tr);
                  }}
                >
                  Edit
                </Button>
              </motion.div>
            ))
          ) : (
            <p className="text-gray-500 italic text-center">
              No trainings added yet.
            </p>
          )}
        </div>
      </section>

      {/* ======================
          CERTIFICATE SECTION
      ====================== */}
      <section>
        <h2 className="text-2xl font-semibold text-[#1A2B63] mb-4">
          Certificate Information
        </h2>

        {/* FORM */}
        <form className="grid grid-cols-2 md:grid-cols-3 gap-5">
          {[
            { label: "Certification Title", name: "certification" },
            { label: "Institution Name", name: "institution" },
            { label: "Enrolled ID", name: "enrolledId" },
            { label: "Country", name: "country" },
            { label: "Status", name: "status" },
            { label: "Modality", name: "modality" },
            { label: "Start Date", name: "startDate", type: "date" },
            { label: "End Date", name: "endDate", type: "date" },
            { label: "Certification URL", name: "certificationUrl", type: "url" },
          ].map((field, i) => (
            <div key={i} className="flex flex-col">
              <label className="text-gray-700 text-sm font-semibold mb-1">
                {field.label}
              </label>
              <input
                type={field.type || "text"}
                name={field.name}
                value={certificateForm[field.name] || ""}
                onChange={(e) => handleChange(e, setCertificateForm)}
                className="border border-blue-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500 outline-none transition-all duration-200"
              />
            </div>
          ))}

          <div className="col-span-full flex justify-end gap-3 mt-2">
            {editCertificateIndex !== null && (
              <Button
                variant="outline"
                onClick={() => setEditCertificateIndex(null)}
              >
                Cancel
              </Button>
            )}
            <Button
              onClick={(e) => {
                e.preventDefault();
                editCertificateIndex !== null
                  ? handleUpdate(
                      certificateForm,
                      editCertificateIndex,
                      setCertificateForm,
                      setCertificateList,
                      "/update-certificate"
                    )
                  : handleAdd(
                      certificateForm,
                      setCertificateForm,
                      setCertificateList,
                      "/update-certificate"
                    );
              }}
              className="bg-blue-600 text-white"
            >
              {editCertificateIndex !== null ? "Update Certificate" : "Add Certificate"}
            </Button>
          </div>
        </form>

        {/* LIST */}
        <div className="mt-8 space-y-4">
          <h3 className="text-xl font-semibold text-[#1A2B63]">
            Certificate History
          </h3>
          {certificateList.length > 0 ? (
            certificateList.map((cf, i) => (
              <motion.div
                key={i}
                initial={{ opacity: 0, y: 10 }}
                animate={{ opacity: 1, y: 0 }}
                className="p-4 bg-blue-50 rounded-lg flex justify-between items-start shadow-sm hover:shadow-md transition-all"
              >
                <div>
                  <p className="font-semibold text-blue-800">{cf.certification}</p>
                  <p className="text-sm text-gray-600">
                    {cf.institution} - {cf.country}
                  </p>
                  <p className="text-sm text-gray-600">
                    {cf.startDate} - {cf.endDate}
                  </p>
                  {cf.certificationUrl && (
                    <a
                      href={cf.certificationUrl}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-blue-600 text-sm underline"
                    >
                      View Certificate
                    </a>
                  )}
                </div>
                <Button
                  size="sm"
                  variant="outline"
                  onClick={() => {
                    setEditCertificateIndex(i);
                    setCertificateForm(cf);
                  }}
                >
                  Edit
                </Button>
              </motion.div>
            ))
          ) : (
            <p className="text-gray-500 italic text-center">
              No certificates added yet.
            </p>
          )}
        </div>
      </section>
    </motion.div>
  );
};

export default TrainingCertificate;
